/**
 * The ONE QueryClient for the app, in its own leaf module so non-React code can reach it.
 *
 * Why it's not created inline in main.tsx any more: the session guard (see session-guard.ts)
 * has to CLEAR this cache the instant the credential changes, and it runs outside React. A
 * module-level singleton is also what makes that clear mandatory — the cache outlives every
 * sign-in/sign-out on a static SPA that never reloads the page.
 */
import { QueryClient } from "@tanstack/react-query";

const NO_RETRY = new Set([
  "identity_changed",
  "sign_in_required",
  "public_unavailable",
  "entitlement_required",
  "scope_not_granted",
  "real_money_not_permitted",
]);

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      // Never retry a request we dropped because the credential changed mid-flight — the
      // query is about to refetch under the new identity anyway (see api.ts `identity_changed`).
      // Nor the "needs sign-in / needs an upgrade" answers: retrying can't change them.
      retry: (count, err) => !NO_RETRY.has(String((err as { code?: string })?.code)) && count < 1,
      refetchOnWindowFocus: false,
    },
  },
});
